// Angular
import { Component } from '@angular/core';
// Layout
import { OffcanvasOptions, LayoutConfigService } from '../../../../core/_base/layout';
// Object-Path
import * as objectPath from 'object-path';

@Component({
	selector: 'kt-quick-panel',
	templateUrl: './quick-panel.component.html',
	styleUrls: ['./quick-panel.component.scss']
})
export class QuickPanelComponent {
	// Public properties
	offcanvasOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-quick-panel',
		closeBy: 'kt_quick_panel_close_btn',
		toggleBy: 'kt_quick_panel_toggler_btn'
    };
    asideDisplay: boolean;
    constructor(
        private layoutConfigService: LayoutConfigService) {}
    ngOnInit(): void {
        const config = this.layoutConfigService.getConfig();
        //this.asideDisplay = objectPath.get(config, 'aside.self.display');
    }
    //setAsideDisplay() {
    //    var config = this.layoutConfigService.getConfig();
    //    config.aside.self.display = this.asideDisplay;
    //    this.layoutConfigService.setConfig(config, true);
    //    location.reload();
    //}
}
